export const useI18audioContextValue = t => {
  const audioContextValue = [
    {
      id: "sampleRate",
      indicator: t("scannerFingerprint.JS.audioContextValue.indicator.1"),
      description: "-",
    },
    {
      id: "state",
      indicator: t("scannerFingerprint.JS.audioContextValue.indicator.2"),
      description: "-",
    },
  ];

  return { audioContextValue };
};
